<div #blur class="container-rtd">
  <div class="rtd-item items-linea">
    <div class="date-mode">      
      <div class="title-report p-4" *ngIf="dashboardtypelegend==='3'">
        <span>{{'REALTIME_DASHBOARD'|translate}} - {{indicators?.dashboarD_NAME}} - {{'STATUSREPORT'|translate}}</span>
      </div>      
      <div class="title-report  p-4" *ngIf="dashboardtypelegend==='1'">        
        <span>{{'REALTIME_DASHBOARD'|translate}} {{'GATE_TO_GATE'|translate}} - {{indicators?.dashboarD_NAME}} - {{'STATUSREPORT'|translate}}</span>
      </div>
      <div class="date-picker search">
        <span class="calendar-title">{{'CALENDAR'|translate}}</span>
        <input class="calendar" type="text" autocomplete="off" value="{{currentDate}}" [disabled]="true">
      </div>
      
      <div *ngIf="isIndustrial">
        <div *ngIf="indicators?.livE_MODE === true">
          <span class="live-on-off">
            {{'LIVEMODEON'|translate}}
          </span>
          <div id="ledOnOff" class="tooltip">
            <div class="tooltiptext">
              <table id="customers">
                <tr>
                  <th id="address">{{'IP_ADDRESS'|translate}}</th>
                  <th id="device">{{'DEVICE'|translate}}</th>
                  <th id="online">{{'ONLINE'|translate}}</th>
                </tr>
                <tr *ngFor="let device of responseStatus?.devices">
                  <td>{{device.iP_ADDRESS}}</td>
                  <td>{{device.sourcedevicE_NAME}}</td>
                  <td *ngIf="device.online">
                    <span class="cmx-icon-check" aria-hidden="false" style="color:#8cc658;"></span>
                  </td>
                  <td *ngIf="!device.online" style="text-align: center;">
                    <span class="cmx-icon-error-rounded-fill" aria-hidden="false" style="color:red;"></span>
                  </td>
                </tr>
              </table>
            </div>
          </div>
        </div>
        <div *ngIf="indicators?.livE_MODE === false">
          <span class="live-on-off">
            {{'LIVE_MODE_OFF'|translate}}
          </span>
          <div class="off"></div>
        </div>
      </div>

    </div>

    <div class="search" *ngIf="!isIndustrial">
      <input (paste)="validatePaste($event)" id="searchtoplate" class="uppercase" type="text" autocomplete="off"
        placeholder="{{'SEARCHHERE'|translate}}" (keypress)="validate($event)">
      <button class="btn-form-control" (click)="searchByPlate()">{{'SEARCH'|translate}}</button>
    </div>

  </div>
  <div class="rtd-item message-search-plate" *ngIf="notFound">
    {{messageNotFound}}
  </div>
  <div class="rtd-item">
    <div class="indicators">
      <div class="indicator">
        <div class="indicator-icon">
          <img src="../../../assets/images/Icons/Clock.png" alt="">
        </div>
        <div class="indicator-content">
          <div>
            <span class="indicator-name">{{'AVG_TIME_TITLE' | translate}} (h:mm)</span>
            <div class="tooltip2">
              <img class="indicator-info" src="../../../assets/images/Icons/Info.png" alt="">
              <div class="tooltiptext">{{'AVG_TIME_TOOLTIP' | translate}}</div>
            </div>
          </div>
          <div class="indicator-value-all">
            <div>
              <span class="indicator-value act-color">{{indicators?.avG_CYCLE_TIME}}</span>
            </div>
            <div>
              <span class="indicator-value-type act-color">min</span>
            </div>
          </div>
          <div>
            <span class="indicator-detail">{{'AVG_TIME_DESC' | translate}}</span>
          </div>
        </div>
      </div>
      <div class="indicator">
        <div class="indicator-icon">
          <img src="../../../assets/images/Icons/Loading.png" alt="">
        </div>
        <div class="indicator-content">
          <div>
            <span class="indicator-name">{{'VOLUME_TITLE' | translate}} (Tons)</span>
            <div class="tooltip2">
              <img class="indicator-info" src="../../../assets/images/Icons/Info.png" alt="">
              <div class="tooltiptext">{{'VOLUME_TOOLTIP' | translate}}</div>
            </div>
          </div>
          <div class="indicator-value-all">
            <div>
              <span class="indicator-value">{{indicators?.volumE_TONS}}</span>
            </div>
            <!-- <div>
              <span class="indicator-value-type">tons</span>
            </div> -->
          </div>
          <div>
            <span class="indicator-detail">{{'VOLUME_DESC' | translate}}</span>
          </div>
        </div>
      </div>
      <div class="indicator">
        <div class="indicator-icon camion">
          <img src="../../../assets/images/Illustrations/Camion-4.png" alt="">
        </div>
        <div class="indicator-content">
          <div>
            <span class="indicator-name">{{'IDENTIFIED_TITLE' | translate}}</span>
            <div class="tooltip2">
              <img class="indicator-info" src="../../../assets/images/Icons/Info.png" alt="">
              <div class="tooltiptext">{{'IDENTIFIED_TOOLTIP' | translate}}</div>
            </div>
          </div>
          <div class="indicator-value-all">
            <div>
              <span class="indicator-value">{{indicators?.registereD_TRUCKS}}</span>
            </div>
            <div>
              <span class="indicator-value-type">{{'TRUCKS' | translate}}</span>
            </div>
          </div>
          <div>
            <span class="indicator-detail">{{'IDENTIFIED_DESC' | translate}}</span>
          </div>
        </div>
      </div>
      <!-- <div class="indicator">
        <div class="indicator-icon camion">
          <img src="../../../assets/images/Illustrations/Camion-2.png" alt="">
        </div>
        <div class="indicator-content">
          <div>
            <span class="indicator-name">Partially identified trucks</span>
            <div class="tooltip2">
              <img class="indicator-info" src="../../../assets/images/Icons/Info.png" alt="">
              <div class="tooltiptext">Total number of events (checkpoints) where a truck was detected but could not
                read
                the license plate or the truck number & company</div>
            </div>
          </div>
          <div class="indicator-value-all">
            <div>
              <span class="indicator-value">{{indicators?.unidentifieD_TRUCKS}}</span>
            </div>
            <div>
              <span class="indicator-value-type">trucks</span>
            </div>
          </div>
          <div>
            <span class="indicator-detail">Total trucks today</span>
          </div>
        </div>
      </div> -->

      <div class="indicator">
        <div class="indicator-icon">
          <img src="../../../assets/images/Icons/Clock.png" alt="">
        </div>
        <div class="indicator-content">
          <div>
            <span class="indicator-name">{{'WAIT_TIME_TITLE' | translate}} (h:mm)</span>
            <div class="tooltip2">
              <img class="indicator-info" src="../../../assets/images/Icons/Info.png" alt="">
              <div class="tooltiptext2">
                {{'WAIT_TIME_TOOLTIP' | translate}}
              </div>
            </div>
          </div>
          <div class="indicator-value-all">
            <div>
              <span class="indicator-value act-color">{{indicators?.waitTime}}</span>
            </div>
            <div>
              <span class="indicator-value-type act-color">min</span>
            </div>
          </div>
          <div>
            <span class="indicator-detail">{{'WAIT_TIME_DESC' | translate}}</span>
          </div>
        </div>
      </div>

    </div>
  </div>
  <!-- <div class="rtd-item p-6">
    <span class="title-rt">{{indicators?.dashboarD_NAME}}</span>
  </div>
  <div class="rtd-item p-10">
    <span class="title-rt">{{'REALTIMESTATUSREPORT'|translate}}</span>
  </div> -->
  <div class="rtd-item">
    <div>
      <p class="detail-rt">
        {{'THISREPORTISLIVE'|translate}}
      </p>
    </div>
  </div>
  <div class="report-container">
    <div class="rtd-item">
      <div>
        <span class="title-facility-point">
          {{'TRUCKSONEARCH'|translate}}
        </span>
      </div>
      <div class="container-stepper">
        <div class="stepper-line"></div>
        <div id="step-{{i+1}}" class="stepper-item" *ngFor="let point of points; let i=index">
          <div class="stepper-item-position" *ngIf="point.avG_TIME_COLOR === 'OK'">{{i+1}}</div>
          <div class="stepper-item-position-error" *ngIf="point.avG_TIME_COLOR === 'ERROR'">{{i+1}}</div>
          <div class="stepper-item-position-warning" *ngIf="point.avG_TIME_COLOR === 'WARNING'">{{i+1}}</div>
          <div class="stepper-item-name">{{point.poinT_NAME}}</div>
        </div>
      </div>
    </div>
    <div class="rtd-item">
      <div class="container-test" *ngIf="type==='6'">
        <div class="item location" *ngFor="let _point of points; let i=index">
          <!-- <div class="item location" (click)="setStep(1)" *ngFor="let _point of points; let i=index"> -->
          <div class="location-item master">
            <div class="master-item">
              <span class="text">{{'TRUCKS_LINE'|translate}}</span>
              <span class="number">{{_point?.inline}}</span>
              <span></span>
            </div>
            <div class="master-item">
              <span class="text">{{'TRUCKS_TIME_SPENT'|translate}}</span>
              <span class="number">{{_point?.avT_FORMAT}}</span>
              <span>min</span>
              <span></span>
            </div>
            <div class="master-item silos">
              <div class="silo" data-point="1" *ngFor="let step of _point.steps; let i = index">
                <!-- {{step.steP_LOC_ID|json}}
                {{_point.poinT_ID|json}} -->
                <div class="name-multi">{{step.steP_LOC_NAME}}</div>
                <div class="view-multi">
                  <img src="../../../../assets/images/Icons/Eye.png" alt="">
                  <span class="text-view"
                    (click)="filter(_point, _point.poinT_ID, step.steP_LOC_ID, step.steP_LOC_NAME,step.order,i)">{{'SELECT'|translate}}</span>
                </div>
              </div>
            </div>
            <div class="master-item">
              <span class="based">{{'BASED_TRUCKS_AREA'|translate}}</span>
            </div>
          </div>
          <div class="location-item detail">
            <div class="ptb-10">
              <!-- <span class="title-detail" id="name-point-{{_point.poinT_ID}}">list of trucks of {{yardName}}</span> -->
              <span class="title-detail" id="name-point-{{_point.poinT_ID}}">{{'LIST_TRUCKS'|translate}}
                {{_point.steps[0]?.steP_LOC_NAME}}</span>
            </div>
            <!-- <div>
              <div [innerHTML]="htmlString | sanitizedHtml"></div>
            </div>
            <div>
              <hr>
            </div> -->
            <div id="point-{{_point.poinT_ID}}" class="plates">
              <!-- <div *ngFor="let step of _point?.steps">
                {{step.steP_LOC_NAME|json}}
                {{step.steP_LOC_ID|json}}
                <div *ngFor="let plate of step.plates">
                  {{plate.licensE_PLATE|json}}
                </div>
                <hr>
              </div> -->
              <ng-container *ngFor="let lp of _point?.steps[0]?.plates">
                <!-- <ng-container *ngFor="let lp of _point?.plates"> -->
                <div class="plate">
                  <!-- <div class="plate" *ngIf="lp.steP_LOC_ID===currentOrder"> -->
                  <div>
                    <!-- <div id="plates-{{_point.poinT_ID}}"> -->
                    <!-- <span *ngIf="lp.licensE_PLATE===''" class="lp-number-red">LP. Unidentified</span> -->
                    <span *ngIf="lp.avG_TIME_COLOR==='ERROR' && lp.licensE_PLATE!==''" class="lp-number-red">#{{lp.trucK_NUMBER}} - LP.
                      {{lp.licensE_PLATE}}</span>
                    <span *ngIf="lp.avG_TIME_COLOR==='OK'" class="lp-number">#{{lp.trucK_NUMBER}} - {{lp.licensE_PLATE}}</span>
                    <span *ngIf="lp.avG_TIME_COLOR==='WARNING'" class="lp-number-w">#{{lp.trucK_NUMBER}} - {{lp.licensE_PLATE}}</span>                    
                  </div>
                  <div>
                    <div class="view-multi">
                      <img src="../../../../assets/images/Icons/Eye.png" alt="">
                      <span class="text-view" (click)="goToModalDetail(lp)">{{'VIEW'|translate}}</span>
                    </div>
                  </div>
                </div>
              </ng-container>
              <div class="text-center" *ngIf="_point?.steps[0]?.plates">
                <span class="show-all">
                  <img src="../../../../assets/images/Icons/Eye.png" alt="">
                  <span class="text-view" (click)=showAll(_point)>{{'SHOW_ALL_TRUCKS'|translate}}</span>
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>      
      <div class="container-test" *ngIf="indicators?.dashboarD_TYPE_ID === 1100">
        <div class="item location" *ngIf="points?.length > 0"> 
          <!-- <div class="item location" (click)="setStep(1)" *ngFor="let _point of points; let i=index"> -->
          <div class="location-item master">
            <div class="master-item">
              <span class="text">{{'TRUCKS_LINE'|translate}}</span>
              <span class="number">{{points[0]?.inline}}</span>
              <span></span>
            </div>
            <div class="master-item">
              <span class="text">{{'TRUCKS_TIME_SPENT'|translate}}</span>
              <span class="number">{{points[0]?.avT_FORMAT}}</span>
              <span>min</span>
              <span></span>
            </div>
            <div class="master-item silos">
              <div class="silo" data-point="1" *ngFor="let step of points[0]?.steps; let i = index">
                <!-- {{step.steP_LOC_ID|json}}
                {{_point.poinT_ID|json}} -->
                <div class="name-multi">{{step.steP_LOC_NAME}}</div>
                <div class="view-multi">
                  <img src="../../../../assets/images/Icons/Eye.png" alt="">
                  <span class="text-view"
                    (click)="filterEntry(step.order, points[0]?.poinT_ID, step.steP_LOC_NAME)">{{'SELECT'|translate}}</span>                            
                </div>
              </div>
            </div>
            <div class="master-item">
              <span class="based">{{'BASED_TRUCKS_AREA'|translate}}</span>
            </div>
          </div>
          <div class="location-item detail">
            <div class="ptb-10">
              <!-- <span class="title-detail" id="name-point-{{_point.poinT_ID}}">list of trucks of {{yardName}}</span> -->
              <span class="title-detail" id="name-point-{{points[0]?.poinT_ID}}-{{1}}">{{'LIST_TRUCKS'|translate}}
                {{points[0]?.steps[0]?.steP_LOC_NAME}}</span>
            </div>
            <div id="point-{{points[0]?.poinT_ID}}" class="plates">
              <ng-container *ngFor="let lp of points[0]?.steps[0]?.plates">
                <div class="plate" *ngIf="currentEntry===lp.order">
                  <div>
                    <span *ngIf="lp.licensE_PLATE===''" class="lp-number-red">#{{lp.trucK_NUMBER}} - LP. {{'UNIDENTIFIED'|translate}}</span>
                    <span *ngIf="lp.avG_TIME_COLOR==='ERROR' && lp.licensE_PLATE!==''" class="lp-number-red">#{{lp.trucK_NUMBER}} - LP.
                      {{lp.licensE_PLATE}}</span>
                    <span *ngIf="lp.avG_TIME_COLOR==='OK'" class="lp-number">#{{lp.trucK_NUMBER}} - LP. {{lp.licensE_PLATE}}</span>
                    <span *ngIf="lp.avG_TIME_COLOR==='WARNING'" class="lp-number-w">#{{lp.trucK_NUMBER}} - LP. {{lp.licensE_PLATE}}</span>
                  </div>
                  <div>
                    <div class="view-multi">
                      <img src="../../../../assets/images/Icons/Eye.png" alt="">
                      <span class="text-view" (click)="goToModalDetail(lp)">{{'VIEW'|translate}}</span>
                    </div>
                  </div>
                </div>
              </ng-container>
              <div class="text-center" *ngIf="points[0]?.steps[0]?.plates">
                <span class="show-all">
                  <img src="../../../../assets/images/Icons/Eye.png" alt="">
                  <span class="text-view" (click)=showAll(points[0])>{{'SHOW_ALL_TRUCKS'|translate}}</span>
                </span>
              </div>
            </div>
          </div>
        </div>
        <div class="item location" *ngIf="points?.length > 1">
          <!-- <div class="item location" (click)="setStep(1)" *ngFor="let _point of points; let i=index"> -->
          <div class="location-item master">
            <div class="master-item">
              <span class="text">{{'TRUCKS_LINE'|translate}}</span>
              <span class="number">{{points[1]?.inline}}</span>
              <span></span>
            </div>
            <div class="master-item">
              <span class="text">{{'TRUCKS_TIME_SPENT'|translate}}</span>
              <span class="number">{{points[1]?.avT_FORMAT}}</span>
              <span>min</span>
              <span></span>
            </div>
            <div class="master-item silos">
              <div class="silo" data-point="1" *ngFor="let step of points[1]?.steps; let i = index">
                <!-- {{step.steP_LOC_ID|json}}
                {{_point.poinT_ID|json}} -->
                <div class="name-multi">{{step.steP_LOC_NAME}}</div>
                <div class="view-multi">
                  <img src="../../../../assets/images/Icons/Eye.png" alt="">
                  <span class="text-view"
                    (click)="filterSilos(step.order, points[1]?.poinT_ID, step.steP_LOC_NAME)">{{'SELECT'|translate}}</span>
                </div>
              </div>
            </div>
            <div class="master-item">
              <span class="based">{{'BASED_TRUCKS_AREA'|translate}}</span>
            </div>
          </div>
          <div class="location-item detail">
            <div class="ptb-10">
              <!-- <span class="title-detail" id="name-point-{{_point.poinT_ID}}">list of trucks of {{yardName}}</span> -->
              <span class="title-detail" id="name-point-{{points[1]?.poinT_ID}}-{{2}}">{{'LIST_TRUCKS'|translate}}
                {{points[1]?.steps[0]?.steP_LOC_NAME}}</span>
            </div>
            <div id="point-{{points[1]?.poinT_ID}}" class="plates">
              <!-- <ng-container *ngFor="let lp of points[1]?.steps[0]?.plates"> -->
              <ng-container *ngFor="let lp of points[1]?.plates">
                <div class="plate" *ngIf="currentSilo===lp.order">
                  <div>
                    <span *ngIf="lp.licensE_PLATE===''" class="lp-number-red">LP. {{'UNIDENTIFIED'|translate}}</span>
                    <span *ngIf="lp.avG_TIME_COLOR==='ERROR' && lp.licensE_PLATE!==''" class="lp-number-red">#{{lp.trucK_NUMBER}} - LP.
                      {{lp.licensE_PLATE}}</span>
                    <span *ngIf="lp.avG_TIME_COLOR==='OK'" class="lp-number">#{{lp.trucK_NUMBER}} - LP. {{lp.licensE_PLATE}}</span>
                    <span *ngIf="lp.avG_TIME_COLOR==='WARNING'" class="lp-number-w">#{{lp.trucK_NUMBER}} - LP. {{lp.licensE_PLATE}}</span>
                  </div>
                  <div>
                    <div class="view-multi">
                      <img src="../../../../assets/images/Icons/Eye.png" alt="">
                      <span class="text-view" (click)="goToModalDetail(lp)">{{'VIEW'|translate}}</span>
                    </div>
                  </div>
                </div>
              </ng-container>
              <div class="text-center" *ngIf="points[1]?.steps[0]?.plates">
                <span class="show-all">
                  <img src="../../../../assets/images/Icons/Eye.png" alt="">
                  <span class="text-view" (click)=showAll(points[1])>{{'SHOW_ALL_TRUCKS'|translate}}</span>
                </span>
              </div>
            </div>
          </div>
        </div>
        <div class="item location" *ngIf="points?.length > 2">          
          <!-- <div class="item location" (click)="setStep(1)" *ngFor="let _point of points; let i=index"> -->
          <div class="location-item master">
            <div class="master-item">
              <span class="text">{{'TRUCKS_LINE'|translate}}</span>
              <span class="number">{{points[2]?.inline}}</span>
              <span></span>
            </div>
            <div class="master-item">
              <span class="text">{{'TRUCKS_TIME_SPENT'|translate}}</span>
              <span class="number">{{points[2]?.avT_FORMAT}}</span>
              <span>min</span>
              <span></span>
            </div>
            <div class="master-item silos">
              <div class="silo" data-point="1" *ngFor="let step of points[2]?.steps; let i = index">
                <!-- {{step.steP_LOC_ID|json}}
                {{_point.poinT_ID|json}} -->
                <div class="name-multi">{{step.steP_LOC_NAME}}</div>
                <div class="view-multi">
                  <img src="../../../../assets/images/Icons/Eye.png" alt="">
                  <span class="text-view"
                    (click)="filterExit(step.order, points[2]?.poinT_ID, step.steP_LOC_NAME)">{{'SELECT'|translate}}</span>
                </div>
              </div>
            </div>
            <div class="master-item">
              <span class="based">{{'BASED_TRUCKS_AREA'|translate}}</span>
            </div>
          </div>
          <div class="location-item detail">            
            <div class="ptb-10">
              <!-- <span class="title-detail" id="name-point-{{_point.poinT_ID}}">list of trucks of {{yardName}}</span> -->
              <span class="title-detail" id="name-point-{{points[2]?.poinT_ID}}-{{3}}">{{'LIST_TRUCKS'|translate}}
                {{points[2]?.steps[0]?.steP_LOC_NAME}}</span>
            </div>
            <div id="point-{{points[2]?.poinT_ID}}" class="plates">
                <ng-container *ngFor="let lp of points[2]?.steps[0]?.plates">
                <div class="plate" *ngIf="currentExit===lp.order">
                    <div>
                      <span *ngIf="lp.licensE_PLATE===''" class="lp-number-red">#{{lp.trucK_NUMBER}} - LP. {{'UNIDENTIFIED'|translate}}</span>
                      <span *ngIf="lp.avG_TIME_COLOR==='ERROR' && lp.licensE_PLATE!==''" class="lp-number-red">#{{lp.trucK_NUMBER}} - LP.
                        {{lp.licensE_PLATE}}</span>
                      <span *ngIf="lp.avG_TIME_COLOR==='OK'" class="lp-number">#{{lp.trucK_NUMBER}} - LP. {{lp.licensE_PLATE}}</span>
                      <span *ngIf="lp.avG_TIME_COLOR==='WARNING'" class="lp-number-w">#{{lp.trucK_NUMBER}} - LP. {{lp.licensE_PLATE}}</span>
                    </div>
                    <div>
                      <div class="view-multi">
                        <img src="../../../../assets/images/Icons/Eye.png" alt="">
                        <span class="text-view" (click)="goToModalDetail(lp)">{{'VIEW'|translate}}</span>
                      </div>
                    </div>
                  </div>
                </ng-container>
              <div class="text-center" *ngIf="points[2]?.steps[0]?.plates">
                <span class="show-all">
                  <img src="../../../../assets/images/Icons/Eye.png" alt="">
                  <span class="text-view" (click)=showAll(points[2])>{{'SHOW_ALL_TRUCKS'|translate}}</span>
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<div id="modalAllTrucks" class="modal">
  <span (click)="closeModalAllTrucks()" class="close">&times;</span>
  <div class="detail-truck">
    <table class="table-control">
      <tr>
        <th>{{'LICENSE_PLATE'|translate}}​</th>
        <th>{{'TRUCK'|translate}}#​​</th>
        <th>{{'START_TIME'|translate}}</th>
        <th>{{'CYCLE_TIME'|translate}}</th>
        <th>{{'DETAIL'|translate}}</th>
      </tr>
      <tr *ngFor="let lp of platesShowAll">
        <td>
          <span *ngIf="lp.licensE_PLATE===''" class="lp-number-red">{{'UNIDENTIFIED'|translate}}</span>
          <span *ngIf="lp.avG_TIME_COLOR==='ERROR' && lp.licensE_PLATE!==''"
            class="lp-number-red">{{lp.licensE_PLATE}}</span>
          <span *ngIf="lp.avG_TIME_COLOR==='OK'" class="lp-number">{{lp.licensE_PLATE}}</span>
          <span *ngIf="lp.avG_TIME_COLOR==='WARNING'" class="lp-number-w">{{lp.licensE_PLATE}}</span>
        </td>
        <td>
          <span *ngIf="lp.trucK_NUMBER===''" class="lp-number-red">{{'UNIDENTIFIED'|translate}}</span>
          <span *ngIf="lp.avG_TIME_COLOR==='ERROR' && lp.trucK_NUMBER!==''" class="lp-number-red">{{lp.trucK_NUMBER}}</span>
          <span *ngIf="lp.avG_TIME_COLOR==='OK'" class="lp-number">{{lp.trucK_NUMBER}}</span>
          <span *ngIf="lp.avG_TIME_COLOR==='WARNING'" class="lp-number-w">{{lp.trucK_NUMBER}}</span>          
        </td>        
        <td>{{lp.dT_START_FORMAT}}</td>
        <td>{{lp.avG_TIME_FORMAT}}</td>
        <td>
          <div class="view-multi">
            <img src="../../../../assets/images/Icons/Eye.png" alt="">
            <span class="text-view" (click)="goToModalDetail(lp)">{{'VIEW'|translate}}</span>
          </div>
        </td>
      </tr>
    </table>
  </div>
</div>

<div id="modalDetail" class="modal">
  <span (click)="closeModalDetail()" class="close">&times;</span>
  <div class="detail-truck">
    <div class="title-detail-truck">
      <span class="title-rt">{{'DETAIL_INFORMATION'|translate}}​</span>
    </div>
    <div class="header-detail-truck">
      <div class="first-item">
        <div class="bold">{{'PLANT'|translate}}​:</div>
        <div>{{responseDetail?.plant}} - #{{responseDetail?.code}}</div>
        <div class="bold">{{'DATE'|translate}}:</div>
        <div>{{responseDetail?.actualStart|ordinalDate}}</div>
      </div>
      <div class="fifty-percent">
        <form [formGroup]="detailTruckForm" (ngSubmit)="UpdateDetailTruck(detailTruckForm.value)">
          <div>
            <span class="bold">{{'VEHICLE'|translate}}</span>
          </div>
          <div class="second-item">
            <div class="filter">
              <div class="small-letter">{{'LICENSE_PLATE'|translate}}:</div>
              <div>
                <input (keyup)="onKeyLP($event)" formControlName="plateNumber" [disabled]="true" class="input-control"
                  type="text" value="{{responseDetail?.platE_NUMBER}}" maxlength="10">
              </div>
            </div>
            <div class="filter">
              <div class="small-letter">{{'TRUCK'|translate}}#:​</div>
              <div>
                <input (keyup)="onKeyTN($event)" formControlName="truckNumber" [disabled]="_edit" class="input-control"
                  type="text" value="{{responseDetail?.truckNumber}}" maxlength="10">
              </div>
            </div>
            <div class="filter">
              <div class="small-letter">{{'COMPANY'|translate}}:​</div>
              <div>
                <select formControlName="govNumber" #company (change)="changeCompany(company.value)" [disabled]="_edit"
                  class="select-control">
                  <option *ngFor="let company of companies" [selected]="company.selected === true"
                    value="{{company.govNumber}}">
                    {{company.name}}</option>
                </select>
              </div>
            </div>
            <div class="filter">
              <div class="small-letter">DOT#:​</div>
              <div>
                <input (keyup)="onKeyDN($event)" formControlName="dotNumber" id="dotNumber" [disabled]="_edit"
                  class="input-control" type="text" value="{{responseDetail?.dotNumber}}" maxlength="10">
              </div>
            </div>
            <div class="filter">
              <div class="small-letter">{{'TYPE'|translate}}:​</div>
              <div>
                <select formControlName="attributeValue" #hola (change)="changeType(hola.value)" [disabled]="_edit"
                  class="select-control">
                  <option *ngFor="let av of types" [selected]="av.selected == true" [ngValue]="av.id">
                    {{av.nameEn}}
                  </option>
                </select>
                <!-- <select formControlName="attributeValue" #type (change)="changeType(type.value)" [disabled]="_edit"
                  class="select-control">
                  <option *ngFor="let av of types" [selected]="av.selected === true" value="{{av.id}}">
                    {{av.nameEn}}
                  </option>
                </select>​​ -->
              </div>
            </div>
          </div>
          <div class="second-item">
            <div>
              <button class="button-control" *ngIf="_edit" (click)="edit()">{{'EDIT'|translate}}</button>
              <button class="button-control" type="submit" *ngIf="!_edit">{{'SAVE'|translate}}</button>
            </div>
          </div>
        </form>
      </div>
      <div id="resolution" class="resolution" style="display: none;">
        <div class="success-msg">
          <i class="fa fa-check"></i>
          {{'UPDATED_SUCCES'|translate}}.
        </div>
      </div>
      <div>
        <div class="first-item">
          <div>{{'COMPLETED_TRIPS'|translate}}:</div>
          <div>{{responseDetail?.amountofjourneys}}</div>
        </div>
        <div class="first-item">
          <div>{{'AVG_COMPLETED_TRIPS'|translate}}:</div>
          <div>{{responseDetail?.avG_TIME}}</div>
        </div>
      </div>
    </div>
    <div class="body-detail-truck">
      <div>
        <div class="tercer-item">
          <span class="bold">{{'ARRIVAL_PLANT'|translate}}:​</span>
        </div>
        <div class="tercer-item">
          <table class="table-control">
            <tr>
              <th>{{'FACILITY_POINT'|translate}}​​</th>
              <th>{{'TIME'|translate}}</th>
              <th>{{'CYCLE_TIME'|translate}}</th>
              <th>{{'TRUCK'|translate}}</th>
              <th>{{'LICENSE'|translate}}</th>
              <th>{{'TRUCK'|translate}} #</th>
              <th>DOT</th>
              <th>{{'COMPANY'|translate}}</th>
            </tr>
            <tr *ngFor="let checkPoint of arribalAtPlant">
              <td>{{checkPoint.steP_NAME}}</td>
              <td>{{checkPoint.averagE_MINUTES_HHMM}}</td>
              <td>{{checkPoint.averagE_TIME}}</td>
              <td>




                <div *ngIf="checkPoint.image_truck_data?.length == 1"  class="container-carrusel">
                  <div>
                    <img *ngIf="checkPoint.image_truck_data[0] !== null" neorisBrokenImage class="small-image" (click)="zoom(checkPoint.image_truck_data)"
                      [src]="checkPoint.image_truck_data[0]" alt="">
                  </div>
                </div>
                <div *ngIf="checkPoint.image_truck_data?.length > 1"  class="container-carrusel">
                  <div>
                    <img *ngIf="checkPoint.image_truck_data[0] !== null" neorisBrokenImage class="small-image" (click)="zoom(checkPoint.image_truck_data)"
                      [src]="checkPoint.image_truck_data[0]" alt="">
                  </div>
                  <div *ngIf="checkPoint.image_truck_data[0] !== null" class="container-carrusel-more">
                    <div class="more-images"></div>
                    <div class="more-images"></div>
                    <div class="more-images"></div>
                  </div>
                </div>
                
              </td>
              <td>
                <img *ngIf="checkPoint.image_license_data !== undefined" neorisBrokenImage
                  (click)="zoom([checkPoint.image_license_data])" class="small-image" [src]="checkPoint.image_license_data"
                  alt="">
              </td>
              <td>
                <img *ngIf="checkPoint.image_truck_number_data !== undefined" neorisBrokenImage
                  (click)="zoom([checkPoint.image_truck_number_data])" class="small-image"
                  [src]="checkPoint.image_truck_number_data" alt="">
              </td>
              <td>
                <img *ngIf="checkPoint.image_dot_data !== undefined" neorisBrokenImage (click)="zoom([checkPoint.image_dot_data])"
                  class="small-image" [src]="checkPoint.image_dot_data" alt="">
              </td>
              <td>
                <img *ngIf="checkPoint.image_company_data !== undefined" neorisBrokenImage
                  (click)="zoom([checkPoint.image_company_data])" class="small-image" [src]="checkPoint.image_company_data"
                  alt="">
              </td>
              <!-- <div>{{checkPoint.image_trailer|json}}</div> -->
            </tr>
          </table>
        </div>
      </div>
    </div>
  </div>
  <div id="myModal" class="modal">
    <span (click)="closeModal()" class="close">&times;</span>
    <img class="modal-content" id="img01" style="display:none;">
    <div class="carousel">
      <div class="carousel__item carousel__item--visible">
        <img [src]="ImagesCheckPoint[0]" alt="" />
      </div>
      <div class="carousel__item" *ngFor="let item of ImagesCheckPoint.slice(1)">
        <img [src]="item" alt="">
      </div>
      <div *ngIf="ImagesCheckPoint.length>1" class="carousel__actions">
        <button id="carousel__button--prev" aria-label="Previous slide" (click)="previousSlide()">
          <
        </button>    
        <button id="carousel__button--next" aria-label="Next slide" (click)="nextSlide()">
          >
        </button>
      </div>
    </div>
  </div>
</div>
